import { create } from 'zustand';

/**
 * 朗读的全局互斥：同一时刻只允许一处在播。
 *
 * 页面里每条回答都有自己的朗读按钮，各自持有一个播放引擎实例。
 * 新的实例开播时把 activeId 改成自己，其余实例订阅到变化后自行停止。
 */
interface TtsPlaybackState {
  /** 当前正在朗读的内容 id（消息 id），无人朗读时为 null */
  activeId: string | null;
  /** 抢占播放权 */
  acquire: (id: string) => void;
  /** 释放播放权；只有自己仍持有时才清空，避免覆盖后来者 */
  release: (id: string) => void;
}

export const useTtsPlaybackStore = create<TtsPlaybackState>((set) => ({
  activeId: null,
  acquire: (id) => set({ activeId: id }),
  release: (id) =>
    set((state) => (state.activeId === id ? { activeId: null } : state)),
}));
